import listingAdapter from '@/features/listing/requests/adapters/listing-adapter';
import { ListingTypeId } from '@/features/listing/types/listing-types';
import { type ListingsVerificationCollection } from '@/features/listing/types/listing-verification-types';
import { type UserListingsDataResponse } from '@/features/listing/types/user-listings-response-types';
import { type UserListingsData } from '@/features/listing/types/user-listings-types';

export default function userListingsAdapter(userListingsResponse: UserListingsDataResponse, userListingsVerification: ListingsVerificationCollection | null): UserListingsData {
  let missingDataFields: UserListingsData['missingDataFields'] = [];
  let listingMissingPhotoId: UserListingsData['listingMissingPhotoId'] = null;

  const userListings = userListingsResponse.listings.map((userListing) => {
    let isDataMissingListing = false;

    if (userListing.missing_data && userListing.missing_data.length > 0) {
      isDataMissingListing = true;
      // Need to have unique values of missing data fields for all listings
      if (userListing.service_type === ListingTypeId.haveapartment || userListing.service_type === ListingTypeId.haveshare) {
        missingDataFields = [...new Set([...missingDataFields, ...userListing.missing_data])];

        if (!listingMissingPhotoId) {
          listingMissingPhotoId = userListing.listing_id;
        }
      }
    }

    if (userListingsVerification?.[userListing.listing_id]?.status) {
      return {
        ...listingAdapter(userListing),
        // @ts-expect-error - ts is shit sometimes
        addressVerificationStatus: userListingsVerification[userListing.listing_id].status,
        isDataMissing: isDataMissingListing,
        missingDataFields: userListing.missing_data,
        verificationDetails: userListingsVerification[userListing.listing_id],
      };
    }

    return {
      ...listingAdapter(userListing),
      isDataMissing: isDataMissingListing,
      missingDataFields: userListing.missing_data,
      verificationDetails: null,
    };
  });

  const uniqueListings = [...new Map(userListings.map((item) => [item.id, item])).values()];
  // if one listing and listing type is haveapartment or haveshare
  const isAddressVerificationShow = uniqueListings.some((listing) => (
    listing.listingTypeId === ListingTypeId.haveapartment || listing.listingTypeId === ListingTypeId.haveshare
  ));

  return {
    count: userListingsResponse.count,
    isAddressVerificationShow,
    isDataMissing: userListingsResponse.is_data_missing,
    listingMissingPhotoId,
    listings: userListings,
    missingDataFields,
  };
}
